import { cva } from "class-variance-authority";
//#region src/components/OverlayTrigger/styles.ts
/**
* Chrome for a control that looks like an input but opens an overlay on click. Shared by
* `SelectTrigger` and `DateRangePicker`'s trigger so both sit at the same height and colour when
* they stand next to each other in a filter row.
*/
const overlayTriggerVariants = cva([
	"tailwindcss-preflight",
	"tw:group",
	"tw:box-border",
	"tw:inline-flex",
	"tw:items-center",
	"tw:justify-between",
	"tw:gap-2",
	"tw:w-full",
	"tw:text-left",
	"tw:rounded",
	"tw:border",
	"tw:border-solid",
	"tw:text-foreground",
	"tw:transition-[color,background-color,border-color,box-shadow]",
	"tw:!outline-hidden",
	"tw:focus:ring-4",
	"tw:data-[state=open]:ring-4",
	"tw:disabled:cursor-not-allowed",
	"tw:aria-disabled:cursor-not-allowed",
	"tw:data-[placeholder]:text-muted-foreground",
	"tw:[&_svg]:shrink-0",
	"tw:[&_svg]:pointer-events-none"
], {
	defaultVariants: {
		variant: "primary",
		state: "default",
		sizing: "medium"
	},
	compoundVariants: [
		{
			variant: "secondary",
			state: "error",
			className: ["tw:bg-error-100", "tw:text-neutral-800"]
		},
		{
			variant: "secondary",
			state: "warning",
			className: ["tw:bg-warning-100", "tw:text-neutral-800"]
		},
		{
			variant: "argo",
			state: "default",
			className: [
				"tw:focus:border-primary",
				"tw:focus:ring-ring/50",
				"tw:data-[state=open]:border-primary",
				"tw:data-[state=open]:ring-ring/50"
			]
		},
		{
			variant: "argo",
			state: "error",
			className: [
				"tw:border-destructive",
				"tw:focus:border-destructive",
				"tw:focus:ring-destructive/20",
				"tw:data-[state=open]:border-destructive",
				"tw:data-[state=open]:ring-destructive/20"
			]
		}
	],
	variants: {
		variant: {
			primary: [
				"tw:bg-input-background",
				"tw:text-foreground",
				"tw:border-input",
				"tw:disabled:opacity-40",
				"tw:aria-disabled:opacity-40",
				"tw:aria-[invalid=true]:border-error-500",
				"tw:aria-[invalid=true]:focus:border-error-500",
				"tw:aria-[invalid=true]:focus:ring-error-200",
				"tw:aria-[invalid=true]:data-[state=open]:border-error-500",
				"tw:aria-[invalid=true]:data-[state=open]:ring-error-200"
			],
			secondary: [
				"tw:bg-secondary",
				"tw:border-secondary",
				"tw:disabled:opacity-40",
				"tw:aria-disabled:opacity-40",
				"tw:aria-[invalid=true]:border-error-500",
				"tw:aria-[invalid=true]:focus:border-error-500",
				"tw:aria-[invalid=true]:focus:ring-error-200",
				"tw:aria-[invalid=true]:data-[state=open]:border-error-500",
				"tw:aria-[invalid=true]:data-[state=open]:ring-error-200"
			],
			argo: [
				"tw:bg-muted",
				"tw:border-input",
				"tw:rounded-[var(--radius-lg,0.25rem)]",
				"tw:text-foreground",
				"tw:disabled:opacity-50",
				"tw:aria-disabled:opacity-50",
				"tw:aria-[invalid=true]:border-destructive",
				"tw:aria-[invalid=true]:focus:border-destructive",
				"tw:aria-[invalid=true]:focus:ring-destructive/20",
				"tw:aria-[invalid=true]:data-[state=open]:border-destructive",
				"tw:aria-[invalid=true]:data-[state=open]:ring-destructive/20"
			]
		},
		sizing: {
			default: [
				"tw:px-4",
				"tw:py-2.5",
				"tw:text-sm/[18px]",
				"tw:h-10",
				"tw:min-h-10"
			],
			medium: [
				"tw:px-4",
				"tw:py-2",
				"tw:text-sm/[18px]",
				"tw:h-9",
				"tw:min-h-9"
			],
			small: [
				"tw:px-4",
				"tw:py-2",
				"tw:text-sm/[16px]",
				"tw:h-8",
				"tw:min-h-8"
			]
		},
		state: {
			default: [
				"tw:focus:border-ring",
				"tw:focus:ring-ring/30",
				"tw:data-[state=open]:border-ring",
				"tw:data-[state=open]:ring-ring/30"
			],
			error: [
				"tw:border-error-500",
				"tw:focus:border-error-500",
				"tw:focus:ring-error-200",
				"tw:data-[state=open]:border-error-500",
				"tw:data-[state=open]:ring-error-200"
			],
			warning: [
				"tw:border-warning-500",
				"tw:focus:border-warning-500",
				"tw:focus:ring-warning-200",
				"tw:data-[state=open]:border-warning-500",
				"tw:data-[state=open]:ring-warning-200"
			]
		}
	}
});
//#endregion
export { overlayTriggerVariants };

//# sourceMappingURL=styles-gzcjOyKv.js.map